import { useCallback, useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import "./touchSwap.css";
import personal from "../../assets/personal.svg";
import content from "../../assets/content.svg";

const vibrate = window.navigator.vibrate;

export const TouchSwap = ({toggleSwap, currentSwap}) => {
    const [isStatic, setStatic] = useState(true);
    const [openState, setOpen] = useState("closedState");
    const [coordinates, setCoordinates] = useState({
        left: 0,
        top: 0
    });
    const [activeItem, setActiveItem] = useState(null);
    const touchSwapRef = useRef(null);
    const togglerRef = useRef(null);
    const touchId = useRef(null);

    const clearTimeoutId = () => touchId.current && clearTimeout(touchId.current);
    const setOpenState = useCallback((nextOpen) => { nextOpen !== openState && setOpen(nextOpen); }, [openState]);

    const toggleSection = useCallback((name = activeItem) => {
        setOpenState("closedState");
        setActiveItem(null);
        if (!name || currentSwap === name) return;
        toggleSwap(name);
    }, [setOpenState, toggleSwap, activeItem, currentSwap]);

    const handleGlobalClick = (ev) => {
        const root = document.querySelector(".swapContainer")
        if (!ev.composedPath().includes(root)) {
            setOpen("closedState");
        }
    }

    useEffect(() => {
        const showSwap = (ev, isHover) => {
            if (isHover && openState === "available") return;
            if (openState === "closedState") {
                clearTimeoutId();
                setStatic(false);
                setOpenState("available");
                vibrate && window.navigator.vibrate(3);
            }
            setCoordinates({
                top: ev.clientY,
                left: ev.clientX
            });
            if (isHover) {
                touchId.current = setTimeout(() => {
                    setOpenState("closedState");
                    document.body.style.overflow = "auto";
                }, 900);
            } else {
                touchId.current = setTimeout(() => {
                    setOpenState("openState");
                    vibrate && window.navigator.vibrate([5, 250, 9]);
                    document.body.style.overflow = "hidden";
                }, 350);
            }
        }

        const touchSwapStart = ev => {
            if (ev.composedPath().includes(togglerRef.current)) return;
            clearTimeoutId();
            if (ev.touches[0].clientX < 2 * window.innerWidth / 3 ) return;
            if (ev.touches[0].clientY < window.innerHeight / 4 ) return;
            touchId.current = setTimeout(() => {
                showSwap(ev.touches[0], false);
            }, 200);
        }

        const touchSwapMove = ev => {
            clearTimeoutId();
            if (openState === "closedState") return;
            if (openState === "available" ||
                Math.abs(ev.touches[0].clientY - coordinates.top) > 200 ||
                Math.abs(ev.touches[0].clientX - coordinates.left) > 200
            ) {
                setActiveItem(null);
                setOpenState("closedState");
                return;
            }
            ev.preventDefault();
            const currentRect = touchSwapRef.current.getBoundingClientRect();
            if (ev.touches[0].clientX > currentRect.left + currentRect.width / 2) return setActiveItem(null);
            if (ev.touches[0].clientY < currentRect.top + currentRect.height / 2) return setActiveItem("home");
            if (ev.touches[0].clientY > currentRect.top + currentRect.height / 2) return setActiveItem("portfolio");
        }

        const touchSwapEnd = () => {
            clearTimeoutId();
            if (openState !== "openState" || isStatic) return;
            document.body.style.overflow = "auto";
            toggleSection();
        }

        window.addEventListener("click", handleGlobalClick);
        document.addEventListener("touchstart", touchSwapStart, { passive: false });
        document.addEventListener("touchmove", touchSwapMove, { passive: false });
        document.addEventListener("touchend", touchSwapEnd);
        !window.location.origin.includes("localhost") && document.addEventListener("contextmenu", e => e.preventDefault());
        return () => {
            window.removeEventListener("click", handleGlobalClick);
            document.removeEventListener("touchstart", touchSwapStart, { passive: false });
            document.removeEventListener("touchmove", touchSwapMove, { passive: false });
            document.removeEventListener("touchend", touchSwapEnd);
            !window.location.origin.includes("localhost") && document.removeEventListener("contextmenu", e => e.preventDefault());
        };
      }, [coordinates, openState, setOpenState, toggleSection, isStatic]);

    return (
        <div className="swapContainer themed menu" ref={togglerRef}>
            <div className={`round reveal align-center toggleMenu ${isStatic ? "" : "unavailable"}`} onClick={() => { setStatic(true); setOpen(openState === "openState" ? "closedState" : "openState");}} onMouseOver={() => setStatic(true)}>
                <img draggable="false" alt="" height="40" width="40" src="https://saison.one/assetsCommon/navigation_menu.svg"/>
            </div>
            {isStatic ?
            <ul className={`menu list align-center nowrap ${openState === "openState" ? "openState" : "closedState"}`}>
                <li className={currentSwap === "home" ? "active" : ""} onClick={() => toggleSection("home")}>
                    <img draggable="false" alt="" height="30" width="30" src={ personal }/>
                    <span><FormattedMessage id="mainWebsite"/></span>
                </li>
                <li className={currentSwap === "portfolio" ? "active" : ""} onClick={() => toggleSection("portfolio")}>
                    <img draggable="false" alt="" height="30" width="30" src={ content }/>
                    <span><FormattedMessage id="fullPortfolio"/></span>
                </li>
            </ul>
        :
            <div style={{left: coordinates.left+"px", top: coordinates.top+"px"}} className={`touchSwap align-center round ${openState}`} ref={touchSwapRef}>
                <div className={`align-center round ${openState ? "available" : "unavailable"}`}/>
                <div className={`img align-center ${currentSwap === "home" ? "active" : activeItem === "home" ? "available" : ""}`}>
                    <img draggable="false" alt="" height="35" width="35" src={ personal }/>
                </div>
                <div className={`img align-center ${currentSwap === "portfolio" ? "active" : activeItem === "portfolio" ? "available" : ""}`}>
                    <img draggable="false" alt="" height="35" width="35" src={ content }/>
                </div>
            </div>
        }

        </div>
    );
}